import { TLocale } from '../infra/locale';

export const EXCHANGE_LINKS: Record<TLocale, string> = {
  en: 'https://tiger.exchange/',
  ru: 'https://tiger.exchange/',
  ua: 'https://tiger.exchange/',
  // es: 'https://tiger.exchange/',
};

export const TERMINAL_MAC_OS_LINKS: Record<TLocale, string> = {
  en: 'https://macos.tiger.com/',
  ru: 'https://macos.tiger.com/',
  ua: 'https://macos.tiger.com/',
  // es: 'https://macos.tiger.com/',
};

export const BEOSWER_LINKS: Record<TLocale, string> = {
  en: 'https://wt.tiger.com/',
  ru: 'https://wt.tiger.com/',
  ua: 'https://wt.tiger.com/',
  // es: 'https://wt.tiger.com/',
};

export const BROKER_LINKS: Record<TLocale, string> = {
  en: 'https://broker.tiger.com/',
  ru: 'https://broker.tiger.com/ru/',
  ua: 'https://broker.tiger.com/',
  // es: 'https://broker.tiger.com/',
};

export const SUPPORT_LINKS: Record<TLocale, string> = {
  en: 'https://support.tiger.trade/v/english/',
  ru: 'https://support.tiger.trade/',
  ua: 'https://support.tiger.trade/v/english/',
  // es: 'https://support.tiger.trade/v/english/',
};

export const SUPPORT_BROKER_LINKS: Record<TLocale, string> = {
  en: 'https://broker-docs.tiger.trade/v/english-2/',
  ru: 'https://broker-docs.tiger.trade/',
  ua: 'https://broker-docs.tiger.trade/v/english-2/',
  // es: 'https://broker-docs.tiger.trade/v/english-2/',
};

export const SUPPORT_MACOS_LINKS: Record<TLocale, string> = {
  en: 'https://wiki-en-macos.tiger.trade/',
  ru: 'https://wiki-ru-macos.tiger.trade/',
  ua: 'https://wiki-en-macos.tiger.trade/',
};

export const SUPPORT_TERMINAL_LINKS: Record<TLocale, string> = {
  en: 'https://wt-docs.tiger.com/en',
  ru: 'https://wt-docs.tiger.com/',
  ua: 'https://wt-docs.tiger.com/',
};

export const LOGIN_WINDOWS_LINKS = {
  en: '/terminal/login',
  ru: '/ru/terminal/login',
  ua: '/ua/terminal/login',
  // es: '/es/terminal/login',
};

export const LOGIN_MACOS_LINKS = {
  en: 'https://macos.tiger.com/login',
  ru: 'https://macos.tiger.com/login',
  ua: 'https://macos.tiger.com/login',
  // es: 'https://macos.tiger.com/login',
};

export const LOGIN_BROKER_LINKS = {
  en: 'https://account.tiger.com/auth',
  ru: 'https://account.tiger.com/auth',
  ua: 'https://account.tiger.com/auth',
  // es: 'https://account.tiger.trade/',
};

// Static screener landing served from public/landings/screener via next.config rewrites
export const SCREENER_LINKS: Record<TLocale, string> = {
  en: '/screener',
  ru: '/ru/screener',
  ua: '/ua/screener',
};
